import { c as _c } from "react/compiler-runtime";
type props = {
  children: React.ReactNode;
} & React.ComponentPropsWithoutRef<'h1'>;
export function H1(t0) {
  const $ = _c(4);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="w-8 border-b-4 border-red-800 pt-1" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== className) {
    t2 = <h1 className={className}>{children}{t1}</h1>;
    $[1] = children;
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}